import React from 'react';
import { Link } from 'react-router-dom';
import ClioLogo from '@clio/design-system-web-components/react/logo';

const ClioTemplatesPracticeAreaCard = ({
  label,
  to,
}: {
  label: string;
  to: string;
}) => (
  <Link to={to} className="w-full">
    <div
      className="flex items-center gap-3 bg-white border border-gray-300 rounded-lg px-5 py-3 cursor-pointer hover:bg-blue-50 hover:border-blue-500 transition-all duration-200 w-full"
      role="button"
      tabIndex={0}
      aria-label={`Select ${label} templates`}
    >
      <div className="flex items-center justify-center rounded-full w-4 h-4">
        <ClioLogo product="gem" className="h-4" />
      </div>
      <span className="text-base font-semibold text-gray-900">{label}</span>
    </div>
  </Link>
);

export default ClioTemplatesPracticeAreaCard;
